module.exports = __webpack_public_path__ + "img/WB.06ee6601.png";